//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";
// FastCrawlLoader imports
import { FastCrawlLoaderCmpt } from "./fast-crawl-loader.component";
import * as s from "./fast-crawl-loader.styles";
import { IContainer, IProps } from "./fast-crawl-loaderTypes";
import { fastCrawlLoaderFragments } from "./FastCrawlLoader.gql";
// material-ui
import withStyles from "@material-ui/core/styles/withStyles";

//////////////////////////
// MODERN SUBSCRIPTIONS
/////////////////////////
class FastCrawlLoaderWrapper extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);
  }

  public render() {
    return <FastCrawlLoaderCmpt {...this.props} />;
  }
}

const FastCrawlLoaderRelay = createFragmentContainer(
  FastCrawlLoaderWrapper,
  fastCrawlLoaderFragments,
);

//////////////////
// REDUX
//////////////////
function mapStateToProps(state: any, _ownProps: IContainer) {
  return {
    fastCrawlFinished: state.onboarding.fastCrawlFinished,
    fastCrawlTeammatesIdentifiedComplete: state.onboarding.fastCrawlTeammatesIdentifiedComplete,
    fastCrawlFlowStateErrorMessage: state.onboarding.fastCrawlFlowStateErrorMessage,
  };
}

export const reduxContainer = connect(mapStateToProps)(FastCrawlLoaderRelay);

//////////////////
// WITH STYLES
//////////////////
export const FastCrawlLoader = withStyles(s.styles)(reduxContainer);
